import React, { Component } from 'react';
import { Sections, type SectionRendererArgs, VIEW_MODES } from '@atlassian/jira-portfolio-3-common';
import {
	SCOPE_ROW_HEIGHT,
	STICKY_HEADER_CONTAINER_PREFIX,
	SECTION_KEYS,
} from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant';

import StickyHeaderCell from '../cell';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from '../styles.module.css';

import type { Props } from './types';

// eslint-disable-next-line jira/react/no-class-components
class FieldsHeader extends Component<Props> {
	// eslint-disable-next-line react/sort-comp
	sectionRenderer = ({ section, index, isDragging }: SectionRendererArgs) => (
		<Sections.Item
			id={section.id}
			key={`section-${section.id}`}
			index={index}
			width={section.width}
			minWidth={section.minWidth}
			// eslint-disable-next-line @typescript-eslint/no-empty-function
			onClick={() => {}}
			// eslint-disable-next-line @typescript-eslint/no-empty-function
			setHovered={() => {}}
			collapsible={section.collapsible}
		>
			<StickyHeaderCell
				isCollapsedField={section.collapsible && section.width === section.minWidth}
				containerId={`${STICKY_HEADER_CONTAINER_PREFIX}-field-${section.id}`}
				isDragging={isDragging}
				width={section.width}
			/>
		</Sections.Item>
	);

	shouldComponentUpdate(nextProps: Props) {
		return !nextProps.isDragging;
	}

	render() {
		const { columns, width, stickyHeaderGeometry, viewNamespace, viewMode, minWidth } = this.props;

		const visibleColumns = columns.filter((column) => column.isVisible);
		if (visibleColumns.length === 0) {
			return null;
		}
		const columnsData = visibleColumns.map((column, index, arr) => ({
			initialWidth: column.defaultWidth,
			minWidth: column.minWidth ?? 24,
			// Last column is flexible to absorb the remaining delta
			isFixed: !(viewMode === VIEW_MODES.LIST && index === arr.length - 1),
			id: column.id,
			isLoading: column.isLoading,
			collapsible: column.isCollapsible,
		}));

		const isViewModeList = viewMode === VIEW_MODES.LIST;
		const linkToParent = isViewModeList ? undefined : SECTION_KEYS.MAIN;
		const id = isViewModeList ? SECTION_KEYS.LIST_FIELD : SECTION_KEYS.FIELD;

		return (
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			<div className={styles.columnHeaderSection}>
				<Sections
					id={id}
					namespace={viewNamespace}
					// @ts-expect-error - TS2322 - Type '{ id: "fields-section"; namespace: string; sectionRenderer: ({ section, index, isDragging }: SectionRendererArgs) => Element; sectionsData: { initialWidth: number | undefined; minWidth: number; isFixed: boolean; id: string; isLoading: boolean; }[]; width: number; height: number | undefined; minHeight: number; linkTo...' is not assignable to type 'IntrinsicAttributes & NamespacedIdProps'.
					sectionRenderer={this.sectionRenderer}
					sectionsData={columnsData}
					width={width}
					minWidth={minWidth}
					height={stickyHeaderGeometry && stickyHeaderGeometry.height}
					minHeight={SCOPE_ROW_HEIGHT}
					/**
					 * CAVEAT of 'linkToParent' with 'isFitParent'
					 *
					 * There are three "Fields" sections (sticky-header, header, and columns),
					 * only ONE section should be linked to the parent IF the sections have `isFitParent=false`.
					 *
					 * `isFitParent=false` where the section does not bound by parent's size, the parent's width get updated after the section resized,
					 * this will resulted with multiple cascading updates on the parent section IF multiple sections linked to the same parent.
					 *
					 * */
					linkToParent={linkToParent}
					isFitParent={!isViewModeList}
				/>
			</div>
		);
	}
}

export default FieldsHeader;
